module.exports = __webpack_public_path__ + "img/feature-education.ac3c72ad.jpg";